// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Divider, Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';

// CUSTOM
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import HourPicker from '../../formFields/HourPicker';
import { formatDateToYmd } from '../../../commons/utils';

import 'dayjs/locale/es'; // 👈 importa el idioma español
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

dayjs.locale('es');

export const DetalleNovedadTurno = (props: any) => {
  const { novedades_turno } = useSelector((state: any) => state.novedadesTurno);

  const {
    formField: { colaborador, responsable, tipoNovedad, fechaNovedad, horaNovedad, description },
  } = props;

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  return (
    <div>
      <div>
        <Grid container>
          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <TextField
              fullWidth
              name={novedades_turno.empleado.name + ' ' + novedades_turno.empleado.last_name}
              label={'Colaborador'}
              defaultValue={
                novedades_turno.empleado.name + ' ' + novedades_turno.empleado.last_name
              }
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <TextField
              fullWidth
              name={novedades_turno.responsable.name + ' ' + novedades_turno.responsable.last_name}
              label={'Responsable'}
              defaultValue={
                novedades_turno.responsable.name + ' ' + novedades_turno.responsable.last_name
              }
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
            <TextField
              fullWidth
              name={novedades_turno.tipoNovedad.name}
              label={'Tipo novedad'}
              defaultValue={novedades_turno.tipoNovedad.name}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            <TextField
              fullWidth
              name={novedades_turno.fecha_novedad}
              label={'Fecha novedad'}
              defaultValue={dayjs(novedades_turno.fecha_novedad).format('D [de] MMM. [de] YYYY')}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid size={{ xs: 3 }} sx={{ padding: 2 }}>
            <TextField
              fullWidth
              name={novedades_turno.hora_novedad}
              label={'Hora novedad'}
              defaultValue={dayjs(novedades_turno.hora_novedad, 'HH:mm:ss').format('hh:mm A')}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* ************ */}

          {/* ************ */}
          <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            <TextAreaField
              name={novedades_turno.descripcion}
              label={'Descripcion'}
              defaultValue={novedades_turno.descripcion}
              variant="outlined"
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          {/* ************ */}

          <Divider />
        </Grid>
      </div>
    </div>
  );
};
